import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useUserRole from "../../hooks/useUserRole";

const RestrictedAccess = ({ children, allowManager = false }) => {
  const navigate = useNavigate();
  const { isAdmin, hasAccessAsDeveloper, isManager } = useUserRole();

  const hasAccess =
    isAdmin || hasAccessAsDeveloper || (allowManager && isManager);

  useEffect(() => {
    if (!hasAccess) {
      navigate("/");
    }
  }, [navigate, hasAccess]);

  return <>{hasAccess && children}</>;
};

export default RestrictedAccess;
